import React, { useState, useEffect } from "react";
import EmptyList from "../Common/EmptyList";
import BlogList from "./Home/BlogList";
import Header3 from "./Home/Header/Header3";
import Internblogs from "./internblogs";
import { collection, query, limit, orderBy, getDocs, where } from "firebase/firestore";
import { db } from "../../useFirebase";

const BHome = () => {
  const [blogs3, setBlogs3] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeatured = async () => {
      try {
        setLoading(true);
        const nowStr = new Date().toISOString();
        const q = query(
          collection(db, "blogs_new"),
          where("createdAt", "<=", nowStr),
          orderBy("createdAt", "desc"),
          limit(10)
        );
        const snapshot = await getDocs(q);
        const fetchedBlogs = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setBlogs3(fetchedBlogs);
      } catch (error) {
        console.error("Error fetching featured blogs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeatured();
  }, []);

  return (
    <div>
      <Internblogs />
      <div>
        {/* Page Header */}
        <Header3 />
        {/* Blog list and Empty List */}
        {loading ?
          <div style={{ textAlign: "center", padding: "20px" }}>Loading Featured...</div>
        : !blogs3.length ?
          <EmptyList />
        : <BlogList blogs={blogs3} />}
      </div>
    </div>
  );
};

export default BHome;
